import { MainDocumentManager } from "./DocumentManager";
import { DocumentNetworkHelper } from "./NetworkHelper";
import { TemplateManager } from "./TemplateManager";

export class DocumentManager {
    networkHelper = DocumentNetworkHelper;
    template: TemplateManager = new TemplateManager();
    main: MainDocumentManager = new MainDocumentManager();
}
